<div class="donut" [ngClass]="{completed: completed}" [ngStyle]="{'background': pieStyle}">
    <div class="number" *ngIf="isAlwaysChunked || activeCount !== count || count === 0">
        <span class="top">{{activeCount}}</span>
        <span class="line">|</span>
        <span class="bottom">{{count}}</span>
    </div>

    <div class="check" *ngIf="!isAlwaysChunked && activeCount == count && count > 0">
        <img src="assets/img/green-check.svg" alt="check">
    </div>
</div>
